package com.evoapps.evoshift.domain.usecase

import com.evoapps.evoshift.domain.model.Owner
import com.evoapps.evoshift.domain.repository.OwnerRepository

class GetOwnerUseCase(
    private val ownerRepository: OwnerRepository
) {
    suspend operator fun invoke(ownerId: String): Result<Owner?> {
        return ownerRepository.getOwner(ownerId)
    }
}
